export default __webpack_public_path__ + "static/media/dc.d5d4dd1d.png";